module.exports = "/images/googlepay.svg?7f64a6837567cb1a456bbaa7ac4b5b83";